import apiService from './ApiService';

class ComunicacionesEmailsService {
  async getConfig() {
    const response = await apiService.get('/ComunicacionesEmails/config');
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener la configuración de comunicaciones.';
      throw new Error(msg);
    }
    return response;
  }

  async getProfesores(colegioId) {
    const qs = colegioId ? `?colegioId=${encodeURIComponent(colegioId)}` : '';
    const response = await apiService.get(`/ComunicacionesEmails/profesores${qs}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener la agenda de profesores.';
      throw new Error(msg);
    }
    return response;
  }

  async createProceso(payload) {
    const response = await apiService.post('/ComunicacionesEmails/procesos', payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear el proceso de comunicación.';
      throw new Error(msg);
    }
    return response;
  }
}

const comunicacionesEmailsService = new ComunicacionesEmailsService();

export default comunicacionesEmailsService;
